import { parseAsString, parseAsStringLiteral, useQueryState, useQueryStates } from 'nuqs';
import { RequirePermission } from '@/app/require-permission';
import { PageHeader } from '@/components/shared/page-header';
import { ErrorState, LoadingState, EmptyState } from '@/components/shared/states';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CheckoutHost } from '../checkout/checkout-host';
import { UnitSelect, useUnitParam } from '../unit';
import { CurrentRegister } from './current-register';
import { HistoryTable } from './history-table';
import { PaymentsTable } from './payments-table';
import { PendingTable } from './pending-table';

const TABS = ['caixa', 'pendencias', 'recebimentos', 'historico'] as const;

function CashContent() {
  const unit = useUnitParam(true);
  const [tab, setTab] = useQueryState('aba', parseAsStringLiteral(TABS).withDefault('caixa').withOptions({ history: 'replace' }));
  const [, setShared] = useQueryStates({ page: parseAsString, q: parseAsString, sort: parseAsString, order: parseAsString }, { history: 'replace' });
  const [, setReceive] = useQueryState('receber', parseAsString.withOptions({ history: 'push' }));
  const branchName = unit.branches.find((b) => b.id === unit.branchId)?.name;

  return (
    <>
      <PageHeader
        title="Caixa"
        description="Abra o caixa, receba atendimentos e confira o fechamento do dia."
        actions={<UnitSelect branches={unit.branches} value={unit.branchId} onChange={unit.setBranchId} />}
      />
      {unit.isLoading ? (
        <LoadingState />
      ) : unit.error ? (
        <ErrorState error={unit.error} onRetry={() => unit.refetch()} />
      ) : !unit.branchId ? (
        <EmptyState title="Nenhuma unidade ativa" description="Cadastre uma unidade em Configurações para operar o caixa." />
      ) : (
        <Tabs
          value={tab}
          onValueChange={(v) => {
            void setShared({ page: null, q: null, sort: null, order: null });
            void setTab(v as (typeof TABS)[number]);
          }}
        >
          <TabsList className="mb-4 flex-wrap">
            <TabsTrigger value="caixa">Caixa atual</TabsTrigger>
            <TabsTrigger value="pendencias">Pendências de recebimento</TabsTrigger>
            <TabsTrigger value="recebimentos">Recebimentos</TabsTrigger>
            <TabsTrigger value="historico">Histórico de caixas</TabsTrigger>
          </TabsList>
          <TabsContent value="caixa">
            <CurrentRegister branchId={unit.branchId} branchName={branchName} />
          </TabsContent>
          <TabsContent value="pendencias">
            <PendingTable branchId={unit.branchId} onReceive={(id) => void setReceive(id)} />
          </TabsContent>
          <TabsContent value="recebimentos">
            <PaymentsTable branchId={unit.branchId} />
          </TabsContent>
          <TabsContent value="historico">
            <HistoryTable branchId={unit.branchId} />
          </TabsContent>
        </Tabs>
      )}
      <CheckoutHost defaultBranchId={unit.branchId} />
    </>
  );
}

export function CashPage() {
  return (
    <RequirePermission anyOf={['cash.operate']}>
      <CashContent />
    </RequirePermission>
  );
}
